// extracted by mini-css-extract-plugin
export var form = "_48-0";